module.exports = __webpack_public_path__ + "static/media/S3N7.b7f3301e.svg";